<template>
  <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Wiadomość sukcesu lub błędu -->
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>

      <h1 class="text-xl md:text-2xl font-bold mb-4 text-center lg:text-left">Dyspozytorzy</h1>

      <DispatcherCreateModal
          :isOpen="isModalOpen"
          @close="closeModal"
          @submit="handleOrderSubmit"
      />

      <DispatcherEditModal
          :isOpen="isEditModalOpen"
          :dispatcherToEdit="editingDispatcher"
          @close="closeEditModal"
          @submit="handleOrderEditSubmit"
      />

      <DispatcherInformationModal
            v-if="showModal"
            :visible="showModal"
            :title="'Szczegóły Dyspozytora #' + (selectedDispatcher?.id || '')"
            :selectedDispatcher="selectedDispatcher"
            :userRole="user.role"
            @close="closeModalInformation"
            @goToProfile="goToProfile"
            @startEditing="startEditing"
            @deleteDispatcher="deleteDispatcher"
      >
          <div class="space-y-4">
            <p><b>ID Dyspozytora:</b> {{ selectedDispatcher?.id }}</p>
            <p><b>Imie:</b> {{ selectedDispatcher?.firstName }}</p>
            <p><b>Nazwisko:</b> {{ selectedDispatcher?.lastName }}</p>
            <p><b>Telefon:</b> {{ selectedDispatcher?.phone }}</p>
            <p><b>Nazwa użytkownika:</b> {{ selectedDispatcher?.username }}</p>
            <p><b>Rola:</b> {{ getRoleInPolish(selectedDispatcher?.role.name) }}</p>
          </div>
      </DispatcherInformationModal>

      <div class="bg-white p-4 rounded-lg shadow-md w-full h-auto overflow-visible dark:bg-dark-box-bg dark:border dark:border-dark-border">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-700 dark:text-dark-text">Lista Dyspozytorów:</h2>

          <DynamicSearch
              :data="dispatchers"
              :keysToSearch="['id', 'firstName', 'lastName', 'username', 'role.name']"
              @search-results="handleSearchResults"
              @clear-search="clearSearch"
              class="mt-4 bg-gray-200 dark:bg-dark-box-bg text-gray-900 dark:text-dark-text w-full md:w-auto"
              placeholder="Wyszukaj..."
          />
        </div>

        <div class="overflow-x-auto w-full">
          <table class="min-w-full bg-white border border-gray-300 rounded-lg dark:bg-dark-table-bg dark:border-dark-border">
            <thead>
            <tr class="bg-gray-50 dark:bg-dark-table-header">
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                ID Dyspozytora
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Imię
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Nazwisko
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Nazwa Użytkownika
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Rola
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="filteredDispatchers.length === 0">
              <td colspan="6" class="text-center py-4 text-red-500 font-semibold dark:text-dark-status-unavailable">
                Brak Dyspozytorów
              </td>
            </tr>
            <tr
                v-else
                v-for="(dispatcher) in paginatedDispatchers"
                :key="dispatcher.id"
                :class="[
                    'border-b border-gray-300 dark:border-dark-border hover:bg-light-hover dark:hover:bg-dark-hover hover:cursor-pointer',
                    selectedDispatcher && dispatcher.id === selectedDispatcher.id ? 'bg-light-hover dark:bg-dark-hover' : ''
                ]"
                @click="showDispatcherDetails(dispatcher)"
            >
              <td class="py-3 px-4 dark:text-dark-text">{{ dispatcher.id }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ dispatcher.firstName }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ dispatcher.lastName }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ dispatcher.username }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ getRoleInPolish(dispatcher.role.name) }}</td>
              <!-- <td class="py-3 px-4 text-right dark:text-dark-text">
                <div class="relative inline-block text-left">
                  <button @click.stop="toggleDropdown(dispatcher.id)" class="text-gray-500 hover:text-gray-700 dark:text-dark-text">
                    <EllipsisVerticalIcon class="h-5 w-5" />
                  </button>
                  <div v-if="dropdownOpen === dispatcher.id" class="origin-top-right absolute left-0 ml-[-10rem] mt-[-2.2rem] w-40 focus:outline-none">
                    <div class="py-1.5 absolute flex space-x-2 bg-gray-200 dark:bg-gray-900 rounded">
                      <button @click.stop="goToProfile(dispatcher)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <UserIcon class="w-4 h-4" />
                      </button>
                      <button @click.stop="startEditing(dispatcher)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <PencilIcon class="w-4 h-4" />
                      </button>
                      <button @click.stop="deleteDispatcher(dispatcher.id)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <TrashIcon class="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </td> -->
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginacja -->
        <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <!-- Informacja o liczbie wyświetlanych elementów -->
          <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
            Wyświetlono {{ (currentPage - 1) * itemsPerPage + paginatedDispatchers.length }} z {{ filteredDispatchers.length }} dyspozytorów
          </div>

          <!-- Kontrolki paginacji -->
          <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
            <button v-if="currentPage > 1"
                    @click="goToPage(1)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Pierwsza strona
            </button>
            <button v-if="currentPage > 1"
                    @click="prevPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              &laquo; Poprzednia
            </button>
            <button v-for="page in visiblePages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                    class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
              {{ page }}
            </button>
            <button v-if="currentPage < totalPages"
                    @click="nextPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Następna &raquo;
            </button>
            <button v-if="currentPage < totalPages"
                    @click="goToPage(totalPages)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Ostatnia strona
            </button>
          </div>
        </div>
      </div>

      <button
          @click="openModal"
          class="fixed bottom-8 right-8 bg-button-bg text-button-text p-4 rounded-full shadow-md transition-transform duration-200 ease-in-out hover:bg-button-hover dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
      >
        <PlusIcon class="h-6 w-6 transition-transform duration-200 ease-in-out transform hover:rotate-45" />
      </button>
    </div>
  </div>
</template>



<script>
    import { useAuthStore } from '@/stores/authStore';
    import AppSidebar from '../AppSidebar.vue';
    import DynamicSearch from '../search/DynamicSearch.vue';
    import { PlusIcon } from "@heroicons/vue/24/solid";
    import dispatchersService from '@/services/dispatchersService';
    import DispatcherEditModal from './DispatcherEditModal.vue';
    import DispatcherCreateModal from './DispatcherCreateModal.vue';
    import { RoleMap } from '../utils/roleMap';
    import DispatcherInformationModal from './DispatcherInformationModal.vue';
    import { useSessionStore } from '@/stores/useSessionStore';

    export default {
      name: 'DispatchersAdminPage',
      components: {
        AppSidebar,
        DynamicSearch,
        // EllipsisVerticalIcon,
        // UserIcon,
        // PencilIcon,
        // TrashIcon,
        PlusIcon,
        DispatcherEditModal,
        DispatcherCreateModal,
        DispatcherInformationModal
      },
      setup() {
        const authStore = useAuthStore();
        const sessionStore = useSessionStore();
        if (authStore.isAuthenticated) {
          authStore.checkExpiration();
        }
        return { user: authStore.user, authStore, sessionStore };
      },
      data() {
        return {
            dispatchers: [],
            filteredDispatchers: [],
            editingDispatcher: null,
            isModalOpen: false,
            isEditModalOpen: false,
            message: '',
            messageType: '',
            progress: 0,
            dropdownOpen: null,
            loading: false,
            currentPage: 1,
            itemsPerPage: 5,
            totalPages: 0,
            visiblePages: [],
            showModal: false,
            selectedDispatcher: null,
            isSearching: false,
        };
      },
      computed: {
        paginatedDispatchers() {
          const start = (this.currentPage - 1) * this.itemsPerPage;
          const end = start + this.itemsPerPage;
          return this.filteredDispatchers.slice(start, end);
        }
      },
      mounted() {
        this.calculateItemsPerPage();
        window.addEventListener("resize", this.calculateItemsPerPage);

        const pageFromUrl = parseInt(this.$route.query.currentPage) || 1;
        this.currentPage = pageFromUrl;

        this.fetchDispatchers().then(() => {
          this.calculateTotalPages();
        });

        this.refreshDispatcher();
      },
      beforeUnmount() {
        if (this.sessionStore.intervalId) {
          clearInterval(this.sessionStore.intervalId); // Oczyść interval, jeśli jest ustawiony
          this.sessionStore.intervalId = null; // Reset interval to prevent any issues if it tries to be cleared again
        }
        window.removeEventListener("resize", this.calculateItemsPerPage);
      },
      methods: {
        refreshDispatcher() {
          this.sessionStore.startInterval(() => {
            if(!this.isSearching) {
              this.fetchDispatchers();
            }
          }, 10000);
        },
        calculateItemsPerPage() {
          const width = window.innerWidth;

          if (width >= 3840) {
            this.itemsPerPage = 24; // 4K monitor
          } else if (width >= 2560) {
            this.itemsPerPage = 15; // 2K monitor
          } else if (width >= 1920) {
            this.itemsPerPage = 8; // Full HD monitor
          } else {
            this.itemsPerPage = 5; // Standardowa wartość
          }

          this.calculateTotalPages();
        },
        showDispatcherDetails(dispatcher) {
          this.selectedDispatcher = dispatcher; // Przypisz wybrane zamówienie
          this.showModal = true; // Pokaż modal
        },
        closeModalInformation() {
          this.selectedDispatcher = null; // Wyczyść dane zamówienia
          this.showModal = false; // Zamknij modal
        },
        calculateTotalPages() {
          this.totalPages = Math.ceil(this.filteredDispatchers.length / this.itemsPerPage) || 1;
          this.updateVisiblePages();
        },
        updateVisiblePages() {
          const range = 5; // Liczba widocznych stron
          const start = Math.max(1, this.currentPage - Math.floor(range / 2));
          const end = Math.min(start + range - 1, this.totalPages);

          this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
        goToPage(page) {
          this.currentPage = page;
          this.updateVisiblePages();
        },
        nextPage() {
          if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.updateVisiblePages();
          }
        },
        prevPage() {
          if (this.currentPage > 1) {
            this.currentPage--;
            this.updateVisiblePages();
          }
        },
        handleSearchResults(filteredData) {
          this.filteredDispatchers = filteredData;
          this.calculateTotalPages();

          this.isSearching = filteredData.length > 0;

          this.goToPage(1);
        },
        clearSearch() {
          this.isSearching = false;

          this.goToPage(1);
        },
        toggleDropdown(dispatcherId) {
            this.dropdownOpen = this.dropdownOpen === dispatcherId ? null : dispatcherId;
        },
        showMessage(msg, type) {
            this.message = msg;
            this.messageType = type === 'success' ? 'success-message' : 'error-message';
            this.progress = 0;

            const interval = 30;
            const duration = 5000;
            const step = 100 / (duration / interval);

            const progressInterval = setInterval(() => {
                this.progress += step;
                if (this.progress >= 100) {
                clearInterval(progressInterval);
                this.progress = 0;
                this.message = '';
                this.messageType = '';
                }
            }, interval);
        },
        openModal() {
          if (!this.isModalOpen) {
            this.isModalOpen = true;
          }
        },
        closeModal() {
          if (this.isModalOpen) {
            this.isModalOpen = false;
          }
        },
        handleOrderSubmit(newDispatcher) {
          if (!this.loading) {
            this.submitCreate(newDispatcher);
          }
        },
        startEditing(dispatcher) {
          this.showModal = false;
          this.openEditModal(dispatcher);
        },
        openEditModal(dispatcher) {
          this.editingDispatcher = dispatcher;
          this.isEditModalOpen = true;
        },
        closeEditModal() {
          this.isEditModalOpen = false;
          this.editingDispatcher = null;
        },
        handleOrderEditSubmit(editingDispatcher) {
          if (!this.loading) {
            this.submitEdit(editingDispatcher);
          }
        },
        async submitCreate(newDispatcher) {
          if (this.loading) return;

          this.loading = true;

          try {
            const dispatcherData = {
                id: newDispatcher.id,
                firstName: newDispatcher.firstName,
                lastName: newDispatcher.lastName,
                phone: newDispatcher.phone,
                role: newDispatcher.role.name
            };

            await dispatchersService.createDispatcher(dispatcherData);
            this.showMessage("Dyspozytor został pomyślnie dodany.", "success");

            await this.fetchDispatchers();
            this.resetNewDispatcher();
            this.closeModal();
          } catch (error) {
            this.showMessage("Wystąpił błąd podczas dodawania dyspozytora.", "error");
            console.error('Błąd podczas tworzenia dyspozytora:', error);
          } finally {
            this.loading = false;
          }
        },
        async submitEdit(editingDispatcher) {
          if (this.loading) return;

          this.loading = true;
          try {
            console.log(editingDispatcher)
            const dispatcherData = {
              id: editingDispatcher.id,
              firstName: editingDispatcher.firstName,
              lastName: editingDispatcher.lastName,
              username: editingDispatcher.username,
              phone: editingDispatcher.phone,
              role: editingDispatcher.role
            };

            console.log(dispatcherData)

            await dispatchersService.updateDispatcher(dispatcherData.id, dispatcherData);
            this.showMessage("Dyspozytor został pomyślnie zaktualizowany.", "success");

            await this.fetchDispatchers();
            this.closeEditModal();
          } catch (error) {
            this.showMessage("Wystąpił błąd podczas aktualizacji dyspozytora.", "error");

            console.error('Błąd podczas aktualizacji dyspozytora:', error);
          } finally {
            this.loading = false;
          }
        },
        getProgressColor() {
            return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
        },
        goToProfile(dispatcher) {
          // console.log(dispatcher, dispatcher.id)
          const currentPage = this.currentPage;

          if (this.user.role === 'ROLE_ADMIN') {
            this.$router.push({
              name: 'DispatcherProfileAdmin', 
              params: {id: dispatcher.id},
              query: {
                returnTo: this.$route.name,
                currentPage: currentPage
              }
            });
          } else {
            this.$router.push({
              name: 'DispatcherProfileDispatcher', 
              params: {id: dispatcher.id},
              query: {
                returnTo: this.$route.name,
                currentPage: currentPage
              }
            });
          }
        },
        getRoleInPolish(role) {
          return RoleMap[role] || 'Nieznana rola';
        },
        resetNewDispatcher() {
          this.newDispatcher = {
            firstName: '',
            lastName: '',
            roleName: ''
          };
          // this.resetErrors();
        },
        async deleteDispatcher(dispatcherId) {
          if (confirm("Czy na pewno chcesz usunąć tego dyspozytora?")) {
            try {
              await dispatchersService.deleteDispatcher(dispatcherId);
              await this.fetchDispatchers();
              this.showMessage("Dyspozytor zostało pomyślnie usunięte.", "success");
              this.closeModalInformation();
            } catch (error) {
              console.error('Błąd podczas usuwania dyspozytora:', error);
              this.showMessage("Wystąpił błąd podczas usuwania dyspozytora.", "error");
            }
          }
        },
        async fetchDispatchers() {
            try {
                const response = await dispatchersService.getAllDispatchers();
                this.dispatchers = response.data;
                this.filteredDispatchers = this.dispatchers;
                this.loading = false;
            } catch (error) {
                this.errorMessage = 'Błąd podczas pobierania szczegółów dyspozytora. Spróbuj ponownie.';
                this.loading = false;
            }
        },
      },
    };
    </script>